export const BRANCH_ROLES = ["CIS", "Teller", "Operations Head"];